
import { Vue, Component, Prop, Model, Watch, Mixins } from 'vue-property-decorator'
import * as T from '@/types'
import { getTagValue, getTagName, getTagColor } from '@/utils'
import S from '@/store'

import InputEntityMixin from '@/mixins/mixin-input-entity.tsx'
import {
    UiColorDot,
} from '@hubsolv/hubsolv-ui'

@Component
export default class InputTag extends Mixins<InputEntityMixin<T.Tag>>(InputEntityMixin) {

    @Prop({ type: Boolean, default: false }) allowAny!: boolean
    @Prop({ type: Array, default: () => [] }) tags!: T.Tag[]

    @S.Tags.Getter all!: T.Tag[]

    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////

    get singularDisplayName () { return 'tag' }
    get pluralDisplayName () { return 'tags' }
    get deactivatable () { return true }

    get divStyle () {
        return {
            display: 'flex',
            'align-items': 'center',
        }
    }

    get dotStyle () {
        return {
            'margin-left': '8px',
        }
    }

    get scopedSlots () {
        return {
            text: (scope: { option: T.Tag }) => {
                return <div style={this.divStyle}>
                    <ui-color-dot small color={getTagColor (scope.option)}/> 
                    <span style={this.dotStyle}>{getTagName (scope.option)}</span>
                </div>
            },
        }
    }

    get entities () {
        if (this.allowAny){
            let newEntities = [...this.tags]
            newEntities.unshift({
                tag: 'Any',
                name: 'Any',
                id: '',
                createdAt: '',
                updatedAt: '',
                color: 'white',
            })
            return newEntities
        } 
        return this.all
    }

    ////////////////////////////////////////////////////////////////
    // methods
    ////////////////////////////////////////////////////////////////

    getOptionValue (tag: T.Tag) { return getTagName(tag) }
    getOptionColor (tag: T.Tag) { return getTagColor(tag) }
    getOptionFilterKey (tag: T.Tag) { return getTagName(tag) }
    getOptionTitle (tag: T.Tag) { return getTagName(tag) }
    isOptionArchived (tag: T.Tag) { return false }
    
}
